import { makeAutoObservable } from 'mobx';
import { AdminVoucherCategoryDto, AdminVoucherDto } from 'services/data-contracts';
import { VoucherCategoryFilterType } from 'types/CommonTypes';
import ServiceHelper from './ServiceHelper';
import { PaginationInfo, getPaginationHeader } from 'libs/helper/paginationUtil';
export interface isValid {
  isValid: boolean;
}

class VoucherFilterStore {
  voucherCategories: AdminVoucherCategoryDto[] = [];

  vouchers: AdminVoucherDto[] = [];

  filteredVouchers: AdminVoucherDto[] = [];

  filteredVoucherCategories: AdminVoucherCategoryDto[] = [];

  paginationInfo: PaginationInfo | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  /**
   * @description 일별 예약 조회
   * @param filter
   */
  getVoucherCategories(filter: VoucherCategoryFilterType) {
    ServiceHelper.adminVoucherService
      ?.getVoucherCategories({
        page: filter.page ? filter.page - 1 : 0,
        size: filter.size ?? 40,
        searchKeyword: filter.keyword ?? '',
      })
      .then((res) => {
        this.voucherCategories = [...res.data];
        this.filteredVoucherCategories = [...res.data];
        this.paginationInfo = getPaginationHeader(res.headers);
      });
  }

  getVouchers(categoryId: number, filter: VoucherCategoryFilterType) {

    ServiceHelper.adminVoucherService?.getVouchers(categoryId, {
      page: filter.page ? filter.page - 1 : 0,
      size: filter.size ?? 40,
      searchKeyword: filter.keyword ?? '',
      status: filter.status as 'OPEN' | 'USED' | 'EXPIRED' | undefined,
    }).then((res) => {
      this.vouchers = [...res.data];
      this.filteredVouchers = [...res.data];
      this.paginationInfo = getPaginationHeader(res.headers);
    });
  }

  unmount() {
    this.voucherCategories = [];
  }
}

export default VoucherFilterStore;
